import React from "react";

export default function AdresIcon(color) {
    return (<svg version="1.1" id="Laag_5" width="80px" height="80px" viewBox="0 0 80 80">
        <polygon fill={color} points="55.216,28.333 33.956,28.333 25.363,23.664 25.842,22.785 34.21,27.333 55.216,27.333 " />
        <path fill={color} d="M53.987,48.793H25.103V22.724h21.761l8.853,4.812v3.1l-1.729,0.006V48.793z M26.103,47.793h26.885V30.646L33.96,30.71l-7.857-4.202V47.793z M26.103,25.374l8.106,4.337l20.507-0.07v-1.51l-8.106-4.406H26.103V25.374z" />
        <rect x="33.586" y="28.028" fill={color} width="1" height="20.265" />
        <path fill={color} d="M51.01,36.498H36.734v-4.072H51.01V36.498z M37.734,35.498H50.01v-2.072H37.734V35.498z" />
        <path fill={color} d="M42.229,58.398H37.41V47.793h4.818V58.398z M38.41,57.398h2.818v-8.605H38.41V57.398z" />
        <g>
            <path fill="#FFFFFF" d="M46.779,35.007h1.11c1.094,0,1.979,0.887,1.979,1.98v1.647v7.642h-9.596v-7.642v-1.647c0-1.096-0.886-1.98-1.979-1.98H46.779z" />
            <path fill={color} d="M50.369,46.777H39.773v-9.791c0-0.815-0.664-1.479-1.479-1.479v-1h9.595c1.367,0,2.479,1.112,2.479,2.479V46.777z M40.773,45.777h8.596v-8.791c0-0.815-0.664-1.479-1.479-1.479h-7.607c0.309,0.413,0.491,0.926,0.491,1.479V45.777z" />
            <line fill="#FFFFFF" x1="42.211" y1="38.394" x2="48.036" y2="38.394" />
            <rect x="42.212" y="37.894" fill={color} width="5.824" height="1" />
            <line fill="#FFFFFF" x1="42.211" y1="40.832" x2="48.036" y2="40.832" />
            <rect x="42.212" y="40.333" fill={color} width="5.824" height="1" />
            <line fill="#FFFFFF" x1="42.211" y1="43.266" x2="48.036" y2="43.266" />
            <rect x="42.211" y="42.766" fill={color} width="5.825" height="1" />
        </g>
    </svg>
    );
}